<template>


<div class="wrapper">
<div class="row">
<div class="col-sm-4 offset-sm-4">

  <br><br>
  <div class="card">

          <div class="card-header">
            <h4 class="card-title">Finish Quote</h4>
          </div>

          <div class="form row">
            <div class="col-sm-12">
              <div class="card-body">

              <div class="form-group">
                <label for="fromlocation">From Location</label>
                <div class="form-group">
                  <input type="text" id="fromlocation" v-model="quote.fromlocation" class="form-control" disabled>
                </div>
              </div>

              <div class="form-group">
                <label for="tolocation">To Location</label>
                <div class="form-group">
                  <input type="text" id="tolocation" v-model="quote.tolocation" class="form-control" disabled>
                </div>
              </div>

              <div class="form-group">
                <label for="shipickupdate">Pick up</label>
                <div class="form-group">
                  <input type="text" id="shipickupdate" class="form-control datetimepicker" v-model="shipickupdate" name="pick up" v-validate="'required|validDate'">
                </div>
              </div>

              <div class="form-group">
                <label for="condeliverydate">Delivery</label>
                <div class="form-group">
                  <input type="text" id="condeliverydate" class="form-control datetimepicker" v-model="condeliverydate" name="delivery" v-validate="'required|validDate'">
                </div>
              </div>

              <div class="form-group">
                <label for="transittime">Transit Time</label>
                <div class="form-group">
                  <input type="text" id="transittime" v-model="quote.transittime" class="form-control">
                </div>
              </div>

              <div class="form-group">
                <label for="basecharge">Base Charge</label>
                <div class="form-group">
                  <input type="text" id="basecharge" v-model="quote.basecharge" class="form-control">
                </div>
              </div>

              <div class="form-group">
                <label for="fuelcharge">Fuel Charge</label>
                <div class="form-group">
                  <input type="text" id="fuelcharge" v-model="quote.fuelcharge" class="form-control">
                </div>
              </div>

              <div class="form-group">
                <label for="bordercharge">Border Charge</label>
                <div class="form-group">
                  <input type="text" id="bordercharge" v-model="quote.bordercharge" class="form-control">
                </div>
              </div>

              <div class="form-group">
                <label for="handlingcharge">Handling Charge</label>
                <div class="form-group">
                  <input type="text" id="handlingcharge" v-model="quote.handlingcharge" class="form-control">
                </div>
              </div>

              <div class="form-group">
                <label for="additionalcharge">Additional Charges</label>
                <div class="form-group">
                  <input type="text" id="additionalcharge" v-model="quote.additionalcharge" class="form-control">
                </div>
              </div>

              <div class="form-group">
                <label for="quotenumber">Quote Number</label>
                <div class="form-group">
                  <input type="text" id="quotenumber" v-model="quote.quotenumber" class="form-control">
                </div>
              </div>


              <div class="form-group">
                <p v-for="error in errors.all()" class="help is-danger">{{ error }}</p>
                <div class="input-group">
                    <button id="statusbutton" v-on:click="beforeFinishQuote" class="btn btn-primary quoteButton">Submit Quote</button>
                </div>
              </div>

              </div>
            </div>
          </div>

  </div>


</div>
</div>
</div>


</template>

<script>
import router from '../../router'
import apiService from '../../services/api.service'
import Vue from 'vue'

import { validateDeliveryAfterPickup } from '../../utils/validation'

let error = '';
let shipickupdate = sessionStorage.getItem('quoteshipickupdate');
let condeliverydate = sessionStorage.getItem('quotedeliverydate');

let quote = { 
  parentrfq: '',
  fromlocation: sessionStorage.getItem('quotefromlocation'),
  tolocation: sessionStorage.getItem('quotetolocation'),
  pickupDateTime: '',
  deliveryDateTime: '',
  transittime: '',
  basecharge: '',
  fuelcharge: '',
  bordercharge: '',
  handlingcharge: '',
  additionalcharge: '',
  quotenumber: '',
};

export default {
  name: 'RFQFinish',
  data: function () {
    return {
      errorMessage: error,
      shipickupdate: shipickupdate,
      condeliverydate: condeliverydate,
      quote,
    }
  },
  beforeMount () {
    error = ''
  },
  mounted() {
    console.log("----mounted " + condeliverydate + " " + shipickupdate);
    setTimeout(() => {
      initDatePickers('#shipickupdate', shipickupdate);
      initDatePickers('#condeliverydate', condeliverydate);
    }, 100);
  },
  methods: {
    beforeFinishQuote: async function (event) {
      await this.$validator.validateAll();
      validateDeliveryAfterPickup(this.shipickupdate, this.condeliverydate, 'delivery', this.$validator.errors);
      if(this.errors.count() === 0) this.finishQuote(event);
    },
    finishQuote: function (event) {
      quote.parentrfq =  this.$route.params.id;
      quote.pickupDateTime = newSafeDate(this.shipickupdate);
      quote.deliveryDateTime = newSafeDate(this.condeliverydate);

      // Send API request
      const headers = { headers: {'X-Raefton-RFQ-ID': quote.parentrfq, 'X-Raefton-Contact-ID': this.$route.params.entity} };
      apiService.put('/kong/api/v1/rfq/finish', quote, headers)
      .then(function (response) {
        // If successful notify the user and segue back to the rfq view
        router.push('/rfq/view/' + quote.parentrfq)
        Vue.toasted.success('Successfully Added Quote', { duration: 3500 })
      })
      .catch(function (error) {
        Vue.toasted.error(error.response.data.Result, { duration: 3500 })
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// finish.vue?3dc59fa8